import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Pagination2 } from "../../../Elements/Pagination";
import DataTable from "../../../Elements/DataTable";
import EmptyDataAlert from "../../../Elements/EmptyDataAlert";
import { DashboardLoading } from "../../../Elements/ServeLoading";
import Popup from "reactjs-popup";
import cookies from "../../../../../../CommonFunction/cookies";
import * as XLSX from "xlsx";
import { usePagination, useTable } from "react-table";
import { DefaultLoanAcc } from "../../../../../../API/Bank/Dashboard";
import { formatDate2 } from "../../../../../../CommonFunction/FormatedDate";
import { useNavigate } from "react-router-dom";
import { FaDownload, FaSpinner } from "react-icons/fa";
import { IoInformationCircleOutline } from "react-icons/io5";
import { Tooltip } from "react-tooltip";

const DefaultLoanAccount = ({ isOpen, onClose, bankID, branchID, role }) => {
  const jwtToken = cookies.get("jwt");
  const navigate = useNavigate();
  const [loanData, setLoanData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [showLoanDetails, setShowLoanDetails] = useState(false);
  const [isExport, setIsExport] = useState(true);
  const [isExportLoading, setExportLoading] = useState();
  const [error, setError] = useState(false);
  const [pagination, setPagination] = useState({
    totalDocs: 0,
    totalPages: 1,
    page: 0,
    limit: 10,
    hasNextPage: false,
    hasPrevPage: false,
  });

  const handleServe = (id) => {
    console.log("Original Id = ", id);
    navigate("/banking/bankDashboard/serviceNotice", {
      state: { id },
    });
  };

  const columns = useMemo(
    () => [
      {
        Header: "Loan Number",
        accessor: "identity_number",
        Cell: ({ row, value }) => (
          <div className="my-1 px-1">
            <p>{value}</p>
          </div>
        ),
      },
      {
        Header: "UCID",
        accessor: "system_id",
        Cell: ({ row }) => {
          const userBorrowers = row?.original?.associatedUserborrower || [];
          const orgBorrowers =
            row?.original?.associatedOrganizationborrower || [];

          // Combine user and organization borrowers into a single list
          const borrower = [
            ...userBorrowers.map((borrower) => ({
              id: borrower.system_id,
              name: borrower.name,
            })),
            ...orgBorrowers.map((borrower) => ({
              id: borrower.system_id,
              name: borrower.name,
            })),
          ];

          return (
            <div className="text-left border-bgclr2 p-1">
              {borrower.length > 0 ? (
                borrower.map((data, index) => (
                  <div
                    key={index}
                    className="flex items-center justify-center gap-2 py-0.5 text-center"
                  >
                    {data?.id ? data?.id : "Null"}
                    <button data-tooltip-id={`tooltip-${data?.id}`}>
                      <span className="text-red-600">
                        <IoInformationCircleOutline size={24} />
                      </span>
                    </button>
                    <Tooltip id={`tooltip-${data?.id}`}>
                      Name: <b>{data?.name || ""}</b>
                    </Tooltip>
                  </div>
                ))
              ) : (
                <p className="text-gray-500 text-center">No Borrower</p>
              )}
            </div>
          );
        },
      },
      {
        Header: "Status",
        accessor: "lastStatusType",
        Cell: ({ row }) => (
          <div className="text-center border-bgclr2">
            <div className="flex items-center gap-2 justify-center border-bgclr2 my-3">
              {row?.original?.lastStatusType}
              <button
                data-tooltip-id={`tooltip-${row?.original?.lastStatusType}`}
              >
                <span className="text-red-600">
                  <IoInformationCircleOutline size={24} />
                </span>
              </button>
              <Tooltip id={`tooltip-${row?.original?.lastStatusType}`}>
                Notice Served:{" "}
                <b>{row?.original?.totalDayCount || ""} Days Elapsed</b>
              </Tooltip>
            </div>
          </div>
        ),
      },
      {
        Header: "Upcoming Notice",
        accessor: "nextNoticeServe",
        Cell: ({ row }) => (
          <div className="text-center border-bgclr2">
            <div className="flex items-center gap-2 justify-center border-bgclr2 my-3">
              {row?.original?.nextNoticeServe?.join(', ')}
            </div>
          </div>
        ),
      },
      {
        Header: "Date",
        accessor: "statusChangeDate",
        Cell: ({ value }) => (
          <div className="text-center border-bgclr2">
            <div className="border-bgclr2 my-3">{formatDate2(value)}</div>
          </div>
        ),
      },
      {
        Header: "Action",
        id: "serve",
        accessor: "",
        Cell: ({ row }) => (
          <button
            className="flex gap-2 items-center mx-2 text-txtclr4 border border-gray-400 px-4 py-1.5 rounded-md bg-bgclr"
            onClick={() => {
              handleServe(row.original.identity_number);
            }}
          >
            Serve
          </button>
        ),
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, page, prepareRow } =
    useTable(
      {
        columns,
        data: loanData,
        initialState: { pageIndex: 0 },
        manualPagination: true,
      },
      usePagination
    );

  const fetchData = useCallback(
    async (page = 1, query = searchQuery) => {
      console.log("Calledddd");
      setLoading(true);
      try {
        const data = await DefaultLoanAcc(!isExport, jwtToken, page, query, bankID, branchID, role);
        console.log("Data is here => ", data);
        if (data?.docs) {
          setLoanData(data?.docs);
          setPagination({
            totalDocs: data?.totalDocs,
            totalPages: data?.totalPages,
            page: data?.page,
            limit: data?.limit,
            hasNextPage: data?.hasNextPage,
            hasPrevPage: data?.hasPrevPage,
          });
          setError(false);
        } else {
          setLoanData([]);
          setError(true);
        }
      } catch (err) {
        console.error("Error fetching data:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    },
    [jwtToken]
  );

  useEffect(() => {
    fetchData();
  }, []);

  const exportToExcel = async () => {
    setExportLoading(true);
    const loansDetails = await DefaultLoanAcc(isExport, jwtToken, "", "", bankID, branchID, role);
    setExportLoading(false);
    const ws = XLSX.utils.json_to_sheet(loansDetails?.docs);

    // Set column widths
    const columnWidths = [
      { wch: 30 },
      { wch: 15 },
      { wch: 15 },
      { wch: 20 },
      { wch: 25 },
    ];
    ws["!cols"] = columnWidths;
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "PaymentData");
    XLSX.writeFile(wb, "PaymentData.xlsx");
  };

  const handleSearch = async () => {
    setLoading(true);
    fetchData(1, searchQuery);
  };

  const nextPage = useCallback(() => {
    if (pagination.hasNextPage) fetchData(pagination.page + 1, searchQuery);
  }, [fetchData, searchQuery, pagination]);

  const previousPage = useCallback(() => {
    if (pagination.hasPrevPage) fetchData(pagination.page - 1, searchQuery);
  }, [fetchData, searchQuery, pagination]);

  return (
    <>
      <Popup
        open={isOpen}
        modal
        closeOnDocumentClick={false}
        className="custom-popup"
      >
        <div className="popup-style popup-content">
          <div className="bg-bgclr8 md:w-[950px] w-[400px]  mx-auto h-[520px] rounded-[14px]">
            <div className="flex justify-between font-avenir text-bgclr px-10 pt-5">
              <h1 className="text-[20px] font-[600] ">
                Loans With Default Reminders
              </h1>
              <div className="flex gap-4">
                <button
                  type="submit"
                  onClick={() => {
                    exportToExcel();
                  }}
                  disabled={loading || isExportLoading}
                  className="flex gap-2 items-center py-1 px-7  bg-bgclr rounded-md text-txtclr"
                >
                  {isExportLoading ? (
                    <FaSpinner size={18} className="animate-spin text-txtclr" />
                  ) : (
                    <FaDownload size={18} />
                  )}{" "}
                  Download Report
                </button>
                <button
                  type="submit"
                  onClick={() => {
                    onClose();
                  }}
                  // disabled={loading || isExportLoading}
                  className="font-bold py-1 px-3 rounded-md bg-red-700 text-txtclr"
                >
                  X
                </button>
              </div>
            </div>
            <div>
              {!showLoanDetails ? (
                <div>
                  <div className="searchBar-style-dashboard">
                    <input
                      type="search"
                      placeholder="Search by loan number"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className="searchBar-input-dashboard"
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, "");
                      }}
                    />
                    <button
                      onClick={() => handleSearch()}
                      className="searchBar-btn-dashboard"
                    >
                      Search
                    </button>
                  </div>
                  {loading ? (
                    <div className="flex justify-center h-[360px] items-center">
                      <DashboardLoading />
                    </div>
                  ) : (
                    <>
                      {loanData.length === 0 ? (
                        <div className="h-screen">
                          <EmptyDataAlert
                            title={
                              error
                                ? "No Loans Found"
                                : "Search Loan by Loan number"
                            }
                          />
                        </div>
                      ) : (
                        <div className="mt-2">
                          <div>
                            <div className="pt-3 w-[900px] mx-auto overflow-x-auto h-[335px] overflow-y-auto ">
                              <DataTable
                                getTableProps={getTableProps}
                                headerGroups={headerGroups}
                                getTableBodyProps={getTableBodyProps}
                                page={page}
                                selectedLoanId={""}
                                prepareRow={prepareRow}
                              />
                            </div>
                            <Pagination2
                              previousPage={previousPage}
                              nextPage={nextPage}
                              canPreviousPage={pagination.hasPrevPage}
                              canNextPage={pagination.hasNextPage}
                              pagination={{
                                page: pagination.page,
                                totalPages: pagination.totalPages,
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              ) : (
                <div></div>
              )}
            </div>
          </div>
        </div>
      </Popup>
    </>
  );
};

export default DefaultLoanAccount;
